import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import vuetify from "./plugins/vuetify";
import store from "./store";
import loader from "vue-ui-preloader";
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import Paginate from "vuejs-paginate";
import Vuetify from "vuetify/lib";
import es from "vuetify/lib/locale/es";
import HighchartsVue from "highcharts-vue";
import VueClipboard from "vue-clipboard2";
import moment from "moment";
// import 'sweetalert2/theme-material-ui/material-ui.scss';
Vue.use(VueClipboard);
Vue.use(HighchartsVue);
import {
  required,
  max,
  min,
  numeric,
  alpha_num,
  confirmed,
  between,
  min_value,
  max_value,
  regex,
  alpha,
  length,
  double,
} from "vee-validate/dist/rules";

import { extend, setInteractionMode } from "vee-validate";
setInteractionMode("eager");

extend("doubleOrNumeric", {
  validate(value, params) {
    return double.validate(value, params) || numeric.validate(value, params);
  },
  message: "{_field_} solo debe contener valores numéricos",
});

extend("double", {
  ...double,
  message: "{_field_} solo debe contener valores numéricos",
});

extend("alpha", {
  ...alpha,
  message: "{_field_} solo debe contener letras",
});
extend("max_value", {
  ...max_value,
  message: "{_field_} valor fuera del rango permitido",
});
extend("min_value", {
  ...min_value,
  message: "{_field_} valor fuera del rango permitido",
});

extend("between", {
  ...between,
  message: "{_field_} valor fuera del rango permitido",
});

extend("required", {
  ...required,
  message: "{_field_} no puede quedar vacío",
});
extend("confirmed", {
  ...confirmed,
  message: "{_field_} no coincide.",
});
extend("max", {
  ...max,
  message: "{_field_} no debe ser mayor de {length} caracteres",
});
extend("min", {
  ...min,
  message: "{_field_} no debe ser menor de {length} caracteres",
});
extend("temp", {
  validate(value) {
    let tempRegex = /^3[0-9]$|3[0-9]\.[0-9]$|40$/;
    return value.match(tempRegex);
  },
  message: "{_field_} no está dentro del rango 30-40",
});
extend("heartRate", {
  validate(value) {
    let heartRateRegex = /^0$|^(4[0-9]|[5-9][0-9]|1[0-9]{2}|2[0-1][0-9]|220)$/;
    return value.match(heartRateRegex);
  },
  message: "{_field_} no está dentro del rango 40-220",
});
extend("satuO", {
  validate(value) {
    let satuORegex = /^(0$|^[0-9]$|[1-9][0-9]$|100)$/;
    return value.match(satuORegex);
  },
  message: "{_field_} no está dentro del rango 0-100",
});
extend("hip", {
  validate(value) {
    let hipRegex = /^0$|^([2-9][0-9]|1[0-9]{2}$|2[0-9]{2}$|300)$/;
    return value.match(hipRegex);
  },
  message: "{_field_} no está dentro del rango 20-300",
});
extend("breathRate", {
  validate(value) {
    let breathRateRegex = /^(0$|[1-9][0-9]$)$/;
    return value.match(breathRateRegex);
  },
  message: "{_field_} no está dentro del rango 10-99",
});

extend("size", {
  validate(value) {
    let sizeRegex = /^999$|^(3[0-9]|[4-9][0-9]|1[0-9]{2}|2[0-1][0-9]|220)$/;
    return value.match(sizeRegex);
  },
  message: "{_field_} no está dentro del rango 30-220",
});

extend("imc", {
  validate(value) {
    let imcRegex = /^999$|^(3[0-9]|[4-9][0-9]|1[0-9]{2}|2[0-1][0-9]|220)$/;
    return value.match(imcRegex);
  },
  message: "{_field_} no está dentro del rango 30-220",
});

extend("nameWithDot", {
  validate(value) {
    var flag = false;
    for (var i = 0; i < value.length; i++) {
      if (value.charAt(i) == ".") {
        flag = true;
        var nameWithDotRegex = /^[a-zA-ZÀ-ÿ]*\.+(\s[a-zA-ZÀ-ÿ]+)+$/;
        return value.match(nameWithDotRegex);
      }
    }
    if (!flag) {
      var namewithoutDotRegex = /^([a-zA-ZÀ-ÿ]+( [a-zA-ZÀ-ÿ]+){0,5})$/;
      return value.match(namewithoutDotRegex);
    }
  },
  message: "{_field_} no válido",
});
extend("email", {
  validate(value) {
    if (value.toUpperCase() == "N/D") {
      return true;
    } else {
      var email = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      //  ...email
      return value.match(email);
    }
  },
  message: "{_field_} incorrecto, ej: juanperez@ejemplo.com",
});
extend("phonenumber", {
  validate(value) {
    if (value.toUpperCase() == "N/D") {
      return true;
    } else {
      var phonenumber = /^[0-9]+$/;
      return value.match(phonenumber);
    }
  },
  message:
    "{_field_} el número telefónico solo debe contener valores numéricos",
});
extend("numeric", {
  ...numeric,
  message: "{_field_} solo debe contener valores numéricos",
});
extend("alpha_num", {
  ...alpha_num,
  message: "{_field_} solo debe contener letras y números",
});
extend("regex", {
  ...regex,
  message: "{_field_} no debe contener caracteres especiales o espacios",
});
extend("length", {
  ...length,
  message: "{_field_} no debe ser mayor o menor a {length} digitos",
});

extend("not_empty", {
  validate: (value) => check(value),
  message: "formato de fecha no válido. utiliza dd/mm/yyyy",
});
function check(value) {
  if (strip(value) == "") {
    return false;
  }
  return true;
}
function strip(html) {
  var doc = new DOMParser().parseFromString(html, "text/html");
  return doc.body.textContent || "";
}

extend("maxSizeFile", {
  validate: (value) => checkSize(value),
  message: "El archivo excede el límite permido (10MB)",
});
function checkSize(value) {
  for (let p in value) {
    const unit = 1000000;
    if (value[p].size <= (unit * 10)) {
      return true;
    }
    return false;
  }
}
extend("date", {
  validate(value) {
    var date = /^(0?[1-9]|[12][0-9]|3[01])[\/\-](0?[1-9]|1[012])[\/\-]\d{4}$/;
    return value.match(date);
  },
  message: "formato de fecha no válido. utiliza dd/mm/yyyy",
});
extend("curp", {
  validate(value) {
    let currentyear = moment()
      .local()
      .format("YY");
    if (value.toUpperCase() == "XXXX999999XXXXXX99") {
      return true;
    }
    value = value.toUpperCase();
    let birthyear = value.charAt(4) + value.charAt(5);
    if (birthyear >= "00" && birthyear <= currentyear) {
      var re = /^([A-Z][AEIOUX][A-Z]{2}\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])[HMX](?:AS|B[CS]|C[CLMSH]|D[FG]|G[TR]|HG|JC|M[CNS]|N[ETL]|OC|PL|Q[TR]|S[PLR]|T[CSL]|VZ|YN|ZS)[B-DF-HJ-NP-TV-Z]{3}[A-J\d])(\d)$/,
        validado = value.match(re);
      if (!validado) return false;
      function digitoVerificador(curp17) {
        var diccionario = "0123456789ABCDEFGHIJKLMNÑOPQRSTUVWXYZ",
          lngSuma = 0.0,
          lngDigito = 0.0;
        for (var i = 0; i < 17; i++)
          lngSuma = lngSuma + diccionario.indexOf(curp17.charAt(i)) * (18 - i);
        lngDigito = 10 - (lngSuma % 10);
        if (lngDigito == 10) return 0;
        return lngDigito;
      }
      if (validado[2] != digitoVerificador(validado[1])) return false;
      return true;
    } else {
      var re = /^([A-Z][AEIOUX][A-Z]{2}\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])[HMX](?:AS|B[CS]|C[CLMSH]|D[FG]|G[TR]|HG|JC|M[CNS]|N[ETL]|OC|PL|Q[TR]|S[PLR]|T[CSL]|VZ|YN|ZS)[B-DF-HJ-NP-TV-Z]{3}[0-9\d])(\d)$/,
        validado = value.match(re);
      if (!validado) return false;
      function digitoVerificador(curp17) {
        var diccionario = "0123456789ABCDEFGHIJKLMNÑOPQRSTUVWXYZ",
          lngSuma = 0.0,
          lngDigito = 0.0;
        for (var i = 0; i < 17; i++)
          lngSuma = lngSuma + diccionario.indexOf(curp17.charAt(i)) * (18 - i);
        lngDigito = 10 - (lngSuma % 10);
        if (lngDigito == 10) return 0;
        return lngDigito;
      }
      if (validado[2] != digitoVerificador(validado[1])) return false;
      return true;
    }
  },
  message: "{_field_} formato no válido.",
});

extend("requiredCurp", {
  ...required,
  message: "{_field_} no puede quedar vacío.",
});

const options = {
  confirmButtonColor: "#2E7D32",
  cancelButtonColor: "#ff7674",
};
Vue.use(loader);
Vue.use(VueSweetalert2, options);

Vue.use(Toast, {
  transition: "Vue-Toastification__bounce",
  maxToasts: 5,
  newestOnTop: true,
  hideProgressBar: true,
});

import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import VCalendar from "v-calendar";
import VueMoment from "vue-moment";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
import "@/assets/css/app.css";
import Calendar from "v-calendar/lib/components/calendar.umd";
import DatePicker from "v-calendar/lib/components/date-picker.umd";

import UtilFront from "./core/UtilFront";
const pluginUtil = {
  install() {
    Vue.utilFront = UtilFront;
    Vue.prototype.$utilFront = UtilFront;
  },
};
Vue.use(pluginUtil);

import PermissionConstants from "./core/PermissionConstants";
const pluginPRM = {
  install() {
    Vue.prm = PermissionConstants;
    Vue.prototype.$prm = PermissionConstants;
  },
};
Vue.use(pluginPRM);

import RouteConstants from "@/app/core/RouteConstants.js";
const pluginRouteConstants = {
  install() {
    Vue.routeConstants = RouteConstants;
    Vue.prototype.$routeConstants = RouteConstants;
  },
};
Vue.use(pluginRouteConstants);

/**Constants use for app, new feature for crudview */
import Constants from "@/app/core/Constants.js";
const pluginConstants = {
  install() {
    Vue.cnst = Constants;
    Vue.prototype.$cnst = Constants;
  },
};
Vue.use(pluginConstants);
Vue.use(Vuetify);
// Register components in your 'main.js'
Vue.component("calendar", Calendar);
Vue.component("date-picker", DatePicker);
Vue.component("paginatesx", Paginate);
// Vue.component("lang", {
//   methods: {
//     changeLocale() {
//       this.$vuetify.lang.current = "es";
//     },
//   },
// });
Vue.component("VueCtkDateTimePicker", VueCtkDateTimePicker);
// Vue.component('Loader', AtomSpinner)

Vue.use(VCalendar, {
  componentPrefix: "vc",
});
Vue.use(VueMoment);

Vue.config.productionTip = false;

export default new Vuetify({
  lang: {
    locales: { es },
    current: "es",
  },
});

new Vue({
  router,
  vuetify,
  store,
  render: function(h) {
    return h(App);
  },
}).$mount("#app");
